var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagSwallowtail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 496C64 504.75 56.75 512 48 512H16C7.25 512 0 504.75 0 496V32C0 14.25 14.25 0 32 0S64 14.25 64 32V496ZM391.371 208L506.354 71.469C512.369 64.312 513.697 54.344 509.76 45.875S497.322 32 487.996 32H96V384H487.996C497.322 384 505.822 378.594 509.76 370.125S512.369 351.687 506.354 344.531L391.371 208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSwallowtail);
export default __webpack_public_path__ + "static/media/flag-swallowtail.1ac3db76911207ca7f99fc67f226eb91.svg";
export { ForwardRef as ReactComponent };